export const FETCH_ALLHOSTEL_REQUEST = 'FETCH_ALLHOSTEL_REQUEST'
export const FETCH_ALLHOSTEL_SUCCESS = 'FETCH_ALLHOSTEL_SUCCESS'
export const FETCH_ALLHOSTEL_FALIURE = 'FETCH_ALLHOSTEL_FALIURE'
